export const WidgetState = {
  START: 0,
  ACTIVE: 1,
  WINDOW_LEVEL: 2,
};

export default {
  WidgetState,
};
